import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const OldPipeLegendSt = {
  Wrap: styled.div`
    background: rgba(255, 255, 255, 0.8);
    border: 1px solid #dfdfdf;
    border-radius: 2px;
    box-sizing: border-box;
  `,
  Inner: styled.div`
    padding: 12px;
  `,
  List: styled.ul`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  Item: styled.li<{ color: string }>`
    display: flex;
    align-items: center;
    gap: 8px;
    color: #3f3f3f;
    font-size: 12px;
    font-weight: 500;
    &:before {
      content: '';
      width: 16px;
      height: 16px;
      border-radius: 2px;
      border: 1px solid rgba(17, 17, 17, 0.2);
      box-sizing: border-box;
      background: ${(p) => p.color};
    }
  `,
};

const OldPipeLegend = () => {
  const { t } = useTranslation();
  const items = [
    { color: '#EE1919', label: '10년 이상' },
    { color: '#F08C4D', label: '5~10년' },
    { color: '#26CB23', label: '5년 미만' },
  ];
  return (
    <OldPipeLegendSt.Wrap>
      <OldPipeLegendSt.Inner>
        <OldPipeLegendSt.List>
          {items.map((i, index) => {
            return (
              <OldPipeLegendSt.Item key={index} color={i.color}>
                {t(i.label)}
              </OldPipeLegendSt.Item>
            );
          })}
        </OldPipeLegendSt.List>
      </OldPipeLegendSt.Inner>
    </OldPipeLegendSt.Wrap>
  );
};

export default OldPipeLegend;
